<template>
  <card :item="item" :type="type">
    <div class="cardbody color3" @click.stop="goDetails(item)">
      <div class="header">
        <div class="header-left">
          <img v-if="item.logo&&item.logo.includes('myhuaweicloud')" :src="item.logo" alt />
          <img v-else src="@/assets/company.png" alt />
        </div>
        <div class="header-right">
          <div class="name">{{item.companyName }}</div>
          <div class="tags">
            <span class="tagItem">工程公司</span>
            <span class="tagItem">团队人数:{{item.teamSize }}人</span>
          </div>
        </div>
      </div>
      <div class="content">
        <el-row :gutter="20">
          <el-col :span="12" class="single_hide contents">
            <span class="color6">主营业务:</span>
            <span class="item_data color3">{{item.serviceTypeName ?item.serviceTypeName :"暂无数据" }}</span>
          </el-col>
          <el-col :span="12" class="single_hide contents">
            <span class="color6">经营业绩:</span>
            <span v-if="item.resultNum/10000>1" class="item_data color3">{{Number((this.item.resultNum/10000).toString().match(/^\d+(?:\.\d{0,1})?/)).toFixed(1)}}亿元</span>
            <span v-if="item.resultNum&&item.resultNum/10000<1" class="item_data color3">{{item.resultNum}}万元</span>
            <span v-if="!item.resultNum" class="item_data color3">/</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" class="single_hide contents">
            <span class="color6">入驻时间:</span>
            <span class="item_data color3">{{item.authTime ?formatDate(item.authTime) : "-" }}</span>
          </el-col>
          <el-col :span="12" class="single_hide contents">
            <span class="color6">经营工队数量:</span>
            <span class="item_data color3">{{item.teamCount ? item.teamCount : 0 }}个工队</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="address single_hide">
      <img src="@/assets/team/locationIcon.png" />
      <span :title="getTitle(item)" style="margin-left: 5px" class="color6"
        >{{ item.provinceName }}{{ item.cityName }}{{ item.districtName
        }}{{ item.address ? item.address : "-" }}</span
      >
    </div>
  </card>
</template>

<script>
import { formatDate } from "@/filters/index"
import { checkDataStatusMessage } from "@/utils/checkDataStatus"
export default {
  name: "cardEngineeringCompany",
  components: {
    card: () => import("@/components/card/card")
  },
  inject: ["cardListCom"],
  props: {
    item: Object,
    type: Number // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
  },
  created(){
    if(this.item.resultNum==='0'){
      return this.item.resultNum=0
    }
  },
  methods: {
    //获取地址
    getTitle(item) {
      return (
        item.provinceName +
        item.cityName +
        item.districtName +
        `${item.address ? item.address : "-"}`
      )
    },
    //跳转详细
    async goDetails({ companyNo }) {
      let type = await checkDataStatusMessage.call(this, this.type, companyNo)
      if (type != 1) {
        return
      }
      let routeUrlU = `${process.env.VUE_APP_MATERIALSURL}/company/?no=${companyNo}&type=1&subMenuId=7`
      window.open(routeUrlU, "_blank")
    },
    formatDate
  }
}
</script>

<style lang="scss" scoped>
.cardbody {
  padding: 10px;
  line-height: 23px;
  cursor: pointer;
  .header {
    display: flex;
    .header-left {
      margin-right: 10px;
      height: 60px;
      img {
        width: 60px;
        height: 60px;
        border: 1px solid #e4e7ed;
        border-radius: 10px;
      }
    }
    .header-right {
      .name {
        margin-bottom: 10px;
        font-size: 16px;
        height: 17px;
        line-height: 17px;
        margin-top: 5px;
      }
      .tags {
        .tagItem {
          display: inline-block;
          margin-right: 5px;
          padding: 0 5px;
          background: rgba(2, 134, 223, 0.1);
          color: #409ee9;
          font-size: 12px;
          height: 20px;
          line-height: 20px;
        }
      }
    }
  }
  .contents{
    height: 19px;
    line-height: 19px;
    margin-top: 10px;
  }
}
.address {
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  border-top: 1px dashed #e4e7ed;
  cursor: pointer;
  img {
    vertical-align: middle;
    margin-top: -4px;
  }
}
.single_hide {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
div {
  box-sizing: border-box;
}
.color6 {
  color: #666666;
}
.color3 {
  color: #333333;
}
</style>
